export default __webpack_public_path__ + "static/media/frog_R2_C4.a2515891.png";